import React from 'react'
import clsx from 'clsx'
//import I18n from 'i18n-js/index.js.erb'
import DateHelper from '../../DateHelper/DateHelper'
class GroupContractPresenterGeneral extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      dateFormat: DateHelper.rubyToDateJS(this.props.date_format),
      timeFormat: DateHelper.rubyToDateJS(this.props.time_format),
    }
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`} <span className="ss-help help" title={I18n.t('group_contract_code_helper_text')}></span></label>
              <div>{this.props.code}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`} <span className="ss-help help" title={I18n.t('group_contract_name_helper_text')}></span></label>
              <div>{this.props.name}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t('begins')} <span className="ss-help help" title={I18n.t('group_contract_start_date_helper_text')}></span></label>
              <div>{this.props.start_date.toString(this.state.dateFormat)}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t('ends')} <span className="ss-help help" title={I18n.t('group_contract_end_date_helper_text')}></span></label>
              <div>{this.props.end_date.toString(this.state.dateFormat)}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t('minimum_stay')} <span className="ss-help help" title={I18n.t('minimum_stay_helper_text')}></span></label>
              <div>{this.props.minimum_stay}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t('maximum_stay')} <span className="ss-help help" title={I18n.t('maximum_stay_helper_text')}></span></label>
              <div>{this.props.maximum_stay}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t('check_in_time')}</label>
              <div>{this.props.check_in_time ? DateHelper.parse(this.props.check_in_time).toString(this.state.timeFormat) : null}</div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t('check_out_time')}</label>
              <div>{this.props.check_out_time ? DateHelper.parse(this.props.check_out_time).toString(this.state.timeFormat) : null}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default GroupContractPresenterGeneral
